module.exports = __webpack_public_path__ + "img/selectActive.971b1c03.svg";